<template>
  <PrivacySection title="6. Tempi di Elaborazione">
    <ul>
      <li>
        <strong>Dati locali (app):</strong> eliminazione immediata tramite impostazioni
        dell'app o disinstallazione
      </li>
      <li>
        <strong>Richieste via email o form:</strong> elaborazione entro
        <strong>30 giorni lavorativi</strong> dalla ricezione della richiesta verificata
      </li>
      <li>
        <strong>Conferma:</strong> riceverai una comunicazione di conferma all'indirizzo
        email indicato nella richiesta, una volta completata l'eliminazione
      </li>
    </ul>
    <p>
      Se la richiesta è particolarmente complessa o numerosa, il termine può essere
      prorogato di ulteriori 30 giorni, previa comunicazione motivata all'interessato,
      come previsto dall'art. 12 del GDPR.
    </p>
  </PrivacySection>
</template>

<script>
import PrivacySection from '@/components/privacy/PrivacySection.vue'

export default {
  name: 'TimelineSection',
  components: {
    PrivacySection
  }
}
</script>
